import React from 'react';
import DeliveryCheckingFunctional from './components/delivery-checking-report-list-functional';
import './delivery-checking-report.scss';

const DeliveryChecking = () => {
	return <DeliveryCheckingFunctional />;
};

export default DeliveryChecking;
